import { render, staticRenderFns } from "./NoPointsLayout.vue?vue&type=template&id=5187eeb6&scoped=true"
import script from "./NoPointsLayout.vue?vue&type=script&lang=js"
export * from "./NoPointsLayout.vue?vue&type=script&lang=js"
import style0 from "./NoPointsLayout.vue?vue&type=style&index=0&id=5187eeb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187eeb6",
  null
  
)

export default component.exports